import React from 'react';
import { useTranslation } from 'react-i18next';
import { ControllerWrapper } from '../../../../hooks/providers/ControllerWrapper';
import { LiliTextInput } from '../../../../DesignSystem/LiliTextInput/LiliTextInput';
import { ExtendedUseFormReturn } from '../../../../hooks/providers/useFormHooks';
import { UpdateVendorFormFieldsMap, UpdateVendorFormProps } from '../../interfaces';

interface UpdateVendorCommonFieldsProps {
  formMethods: ExtendedUseFormReturn<UpdateVendorFormProps>
}

export const DomesticWireTransferFields = (props: UpdateVendorCommonFieldsProps) => {
  const { formMethods: { control } } = props;
  const { t } = useTranslation();

  return (
    <>
      <ControllerWrapper name={UpdateVendorFormFieldsMap.WIRE_ACCOUNT_NUMBER} control={control}>
        { ({ onBlur, onChange, error, value }) => <LiliTextInput
          onChange={onChange}
          value={value}
          onBlur={onBlur}
          id={UpdateVendorFormFieldsMap.WIRE_ACCOUNT_NUMBER}
          title={t('MOVE_MONEY.STEPS.VENDOR_MANAGER.ADDITIONAL_FIELDS.WIRE_ACCOUNT')}
          maxLength={17}
          errorMessage={error?.message}
        /> }
      </ControllerWrapper>

      <ControllerWrapper name={UpdateVendorFormFieldsMap.WIRE_ROUTING_NUMBER} control={control}>
        { ({ onBlur, onChange, error, value }) => <LiliTextInput
          onChange={onChange}
          value={value}
          onBlur={onBlur}
          maxLength={9}
          id={UpdateVendorFormFieldsMap.WIRE_ROUTING_NUMBER}
          title={t('MOVE_MONEY.STEPS.VENDOR_MANAGER.ADDITIONAL_FIELDS.WIRE_ROUTE')}
          errorMessage={error?.message}
        /> }
      </ControllerWrapper>
    </>
  );
};
